import React, { useState, useMemo } from 'react';
import { API_BASE_URL } from '../../utils';
import './ClubMenuCards.css';
import ImageWithSkeleton from './ImageWithSkeleton';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Autoplay, Pagination } from 'swiper/modules';


const url = `${API_BASE_URL}/master/assets/uploads/`;

export default function ClubMenuCards({ menus = [] }) {
  // Extract unique category list from item.name (without 'All')
  const categories = useMemo(() => {
    const all = menus.map(item => item.name);
    return [...new Set(all)];
  }, [menus]);

  // Set initial state to first category or empty string if no categories
  const [selectedCategory, setSelectedCategory] = useState(categories[0] || '');

  // Update selectedCategory when categories change (when menus load)
  React.useEffect(() => {
    if (categories.length > 0 && !selectedCategory) {
      setSelectedCategory(categories[0]);
    }
  }, [categories, selectedCategory]);

  // Filtered menus based on selected category
  const filteredMenus = useMemo(() => {
    return menus.filter(item => item.name === selectedCategory);
  }, [menus, selectedCategory]);

  // Image count per category (without 'All')
  const imageCountByCategory = useMemo(() => {
    const countMap = {};

    menus.forEach(item => {
      const cat = item.name;
      const imgCount = item.images?.length || 0;
      countMap[cat] = (countMap[cat] || 0) + imgCount;
    });

    return countMap;
  }, [menus]);




  return (
    <div className="club-cmc-gallery-empty-container">
      {menus.length === 0 ? (
        <div className="club-cmc-gallery-empty-content">
          <h1>No Menu Cards Available</h1>
          <p>We're working on an exciting menu to give you the best value and experience.</p>
          <img
            src="https://illustrations.popsy.co/gray/web-design.svg"
            alt="Coming Soon"
            className="club-cmc-gallery-empty-image"
          />
        </div>
      ) : (
        <div className="club-cmc-gallery-container">
          {/* Filter Buttons */}
          <div className="club-cmc-gallery-filters">
            {categories.map((cat, i) => (
              <span
                key={i}
                className={`club-cmc-filter-button ${selectedCategory === cat ? 'cmc-active' : ''}`}
                onClick={() => setSelectedCategory(cat)}
              >
                {cat} {'\u0028'}{imageCountByCategory[cat] || 0}{'\u0029'}
              </span>
            ))}
          </div>

          <div className="club-cmc-gallery-content">
            {filteredMenus?.map((item, index) => {
              const imageCount = item?.images?.length || 0;

              // Render Swiper only if there are more than 4 images
              const shouldUseSwiper = imageCount > 4;

              return (
                <div key={index} className="club-cmc-gallery-item">
                  <h2>{item.name}</h2>
                  <div className="club-cmc-gallery-images">
                    {shouldUseSwiper ? (
                      <Swiper
                        loop={imageCount > 2}
                        autoplay={
                          imageCount > 1
                            ? {
                              delay: 3000,
                              disableOnInteraction: false,
                            }
                            : false
                        }
                        pagination={{ clickable: true }}
                        spaceBetween={20}
                        breakpoints={{
                          0: { slidesPerView: 2, spaceBetween: 10 },
                          480: { slidesPerView: 2, spaceBetween: 10 },
                          640: { slidesPerView: 2.5, spaceBetween: 12 },
                          768: { slidesPerView: 3, spaceBetween: 16 },
                          1024: { slidesPerView: 4, spaceBetween: 20 },
                        }}
                        modules={[Autoplay, Pagination]}
                      >
                        {item.images.map((image, imgIndex) => (
                          <SwiperSlide key={imgIndex}>
                            <ImageWithSkeleton
                              src={`${url}${image.img}`}
                              alt={`Gallery item ${imgIndex + 1}`}
                              caption={`${item.name}, Image ${imgIndex + 1} of ${item.images.length}`}
                              fancybox="menu-gallery"
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    ) : (
                      // Static image display for 4 or fewer images
                      <div className="club-cmc-gallery-static-grid">
                        {item.images.map((image, imgIndex) => (
                          <div className='club-cmc-gallery-static-grid-item'>
                          <ImageWithSkeleton
                            key={imgIndex}
                            src={`${url}${image.img}`}
                            alt={`Gallery item ${imgIndex + 1}`}
                            caption={`${item.name}, Image ${imgIndex + 1} of ${item.images.length}`}
                            fancybox="menu-gallery"
                          />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}

          </div>

        </div>
      )}
    </div>
  );
}